import React from "react";

import { createGlobalStyle } from "styled-components";

import { LeasingProductPageContent } from "./leasing-product-page-content";
import { PrintStyleSheet } from "../../components/seller/advert-seller-details/location/location.styles";
import { LeasingProvider } from "../../contexts/leasing/context/leasing.context";

const GlobalStyle = createGlobalStyle`
  body {
    @media print {
      @page {
        margin: 0;
      }
      body {
        margin: 0;
      }
      nav#atds-navigation {
        ${PrintStyleSheet}
      }
    }
  }
`;

const LeasingProductPage = () => {
  return (
    <>
      <GlobalStyle />
      <LeasingProvider>
        <LeasingProductPageContent />
      </LeasingProvider>
    </>
  );
};

export default LeasingProductPage;
